import { render, staticRenderFns } from "./CompanyFollowup.vue?vue&type=template&id=06b8dbe2&scoped=true"
import script from "./CompanyFollowup.vue?vue&type=script&lang=js"
export * from "./CompanyFollowup.vue?vue&type=script&lang=js"
import style0 from "./CompanyFollowup.vue?vue&type=style&index=0&id=06b8dbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8dbe2",
  null
  
)

export default component.exports